var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("el-input", {
          staticStyle: { width: "auto" },
          attrs: { value: "", placeholder: "设备id", type: "text" },
          model: {
            value: _vm.deviceId,
            callback: function ($$v) {
              _vm.deviceId = $$v
            },
            expression: "deviceId",
          },
        }),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { width: "auto" },
          attrs: { value: "", placeholder: "code", type: "text" },
          model: {
            value: _vm.thecode,
            callback: function ($$v) {
              _vm.thecode = $$v
            },
            expression: "thecode",
          },
        }),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "el-button",
          {
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugOpen()
              },
            },
          },
          [_vm._v("连接")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugClose()
              },
            },
          },
          [_vm._v("关闭")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugSeeId()
              },
            },
          },
          [_vm._v("查看")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugClearReady()
              },
            },
          },
          [_vm._v("清理")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sureShow,
                expression: "sureShow",
              },
            ],
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugClear()
              },
            },
          },
          [_vm._v("确认清理")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sureShow,
                expression: "sureShow",
              },
            ],
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugClearVoice()
              },
            },
          },
          [_vm._v("确认清理声音文件")]
        ),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("el-input", {
          staticStyle: { width: "auto" },
          attrs: { value: "", placeholder: "日志文件名" },
          model: {
            value: _vm.logfile,
            callback: function ($$v) {
              _vm.logfile = $$v
            },
            expression: "logfile",
          },
        }),
        _vm._v(" "),
        _c(
          "el-button",
          {
            ref: "more",
            attrs: { type: "info" },
            on: {
              click: function ($event) {
                return _vm.debugGetLog()
              },
            },
          },
          [_vm._v("获取日志")]
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "text-result" } }, [
          _vm._v(_vm._s(_vm.result)),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }